import styled from 'styled-components';
import { Label as label, FormGroup as formGroup } from 'reactstrap';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const PageSizeContainer = styled.div`
  width: 56px;
  margin-right: 35px;
`;

export const Label = styled(label)`
  margin-bottom: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
  & ~ & {
    margin-right: 35px;
  }
`;

export const FormGroup = styled(formGroup)`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;
